import { fromJS, Map } from 'immutable';
import { combineReducers } from 'redux';
import getApiReducer from '../../common/utils/getApiReducer';
import courses from '../courses/redux/reducers';
import golfSchools from '../coaching/golf-schools/redux/reducers';
import movementSpecialists from '../coaching/movement-specialists/redux/reducers';
import movementSpecialistAdmin from '../movement-specialist-admin/redux/reducers';
import library from '../library/redux/reducers';
import onlineFollowUp from '../coaching/online-follow-up/redux/reducers';
import inPersonFollowUp from '../coaching/in-person-follow-up/redux/reducers';
import favorites from '../library/favorites/redux/reducers';
import swingSubmittals from '../coaching/swing-submittals/redux/reducers';
import tv from '../tv/redux/reducers';

import { GET_USER } from '../../redux/actions';
import { CREATE_SUBSCRIPTION, UPDATE_SUBSCRIPTION, CANCEL_SUBSCRIPTION, GET_TATHATA_FOLLOW_UP_DATA } from './actions';
import { ENROLL_COURSE } from '../courses/redux/actions';
import {
  UPDATE_MOVEMENT_SPECIALIST_PROFILE,
  CONNECT_STRIPE_EXPRESS_ACCOUNT,
} from '../movement-specialist-admin/redux/actions';
import { SET_USER_VIEWED_MS_INTRODUCTION } from '../coaching/movement-specialists/redux/actions';
import {
  CANCEL_MS_SESSION_FOR_USER,
  CANCEL_TATHATA_SESSION_FOR_USER,
  GET_MEMBER_SESSIONS,
} from '../sessions/redux/actions';
import { REGISTER_FOR_CLASS } from '../coaching/golf-schools/redux/actions';
import { GET_DASHBOARD_DATA } from '../dashboard/redux/actions';

import {
  GET_PROFILE_DATA,
  UPDATE_USER,
  UPDATE_USER_HANDICAP,
  UPDATE_USER_SCORE,
  UPDATE_USER_DRIVING_DISTANCE,
  UPDATE_USER_7IRON_DISTANCE,
} from '../profile/redux/actions';

import { COMPLETE_CHAPTER, COMPLETE_COURSE } from '../courses/redux/actions';

const createSubscription = getApiReducer(CREATE_SUBSCRIPTION);

const sessionsReducer = getApiReducer(GET_MEMBER_SESSIONS);
const sessions = (state, action) => {
  const nextState = sessionsReducer(state, action);

  if (
    action.type === `${CANCEL_MS_SESSION_FOR_USER}_SUCCESS` ||
    action.type === `${CANCEL_TATHATA_SESSION_FOR_USER}_SUCCESS`
  ) {
    const data = state.get('data');
    const index = data.findIndex(item => item.get('id') === parseInt(action.sessionId, 10));

    return nextState.set('data', data.delete(index));
  }

  return nextState;
};

const userReducer = getApiReducer(GET_USER);
const user = (state, action) => {
  const nextState = userReducer(state, action);
  if (action.type === `${ENROLL_COURSE}_SUCCESS` || action.type === `${GET_PROFILE_DATA}_SUCCESS`) {
    return nextState.mergeIn(['data'], fromJS(action.json));
  }

  if (
    action.type === `${UPDATE_MOVEMENT_SPECIALIST_PROFILE}_SUCCESS` ||
    action.type === `${CONNECT_STRIPE_EXPRESS_ACCOUNT}_SUCCESS`
  ) {
    const msProfile = nextState.getIn(['data', 'movementSpecialistProfile']).merge(fromJS(action.json));

    return nextState.setIn(['data', 'movementSpecialistProfile'], msProfile);
  }

  if (action.type === `${SET_USER_VIEWED_MS_INTRODUCTION}_SUCCESS`) {
    return nextState.setIn(['data', 'viewed_ms_intro'], true);
  }

  if (action.type === `${CREATE_SUBSCRIPTION}_SUCCESS`) {
    const nextSubscriptions = nextState.getIn(['data', 'subscriptions']).push(fromJS(action.json));
    return nextState.setIn(['data', 'subscriptions'], nextSubscriptions);
  }

  if (action.type === `${UPDATE_SUBSCRIPTION}_SUCCESS`) {
    const nextSubscriptions = nextState.getIn(['data', 'subscriptions']).map(subscription => {
      if (subscription.get('id') === action.subscriptionId) {
        return fromJS(action.json);
      }
      return subscription;
    });
    return nextState.setIn(['data', 'subscriptions'], nextSubscriptions);
  }

  if (action.type === `${CANCEL_SUBSCRIPTION}_SUCCESS`) {
    const nextSubscriptions = nextState.getIn(['data', 'subscriptions']).map(subscription => {
      if (subscription.get('id') === action.subscriptionId) {
        return subscription.set('cancel_at_period_end', true);
      }
      return subscription;
    });
    return nextState.setIn(['data', 'subscriptions'], nextSubscriptions);
  }

  if (action.type === `${REGISTER_FOR_CLASS}_SUCCESS`) {
    const nextClasses = nextState.getIn(['data', 'classes']).push(fromJS({ id: action.classId }));

    return nextState.setIn(['data', 'classes'], nextClasses);
  }

  if (action.type === `${UPDATE_USER}_SUCCESS`) {
    const field = Object.keys(action.payload)[0];
    return nextState.setIn(['data', field], action.payload[field]);
  }

  if (action.type === `${UPDATE_USER_HANDICAP}_SUCCESS`) {
    return nextState.setIn(['data', 'handicaps'], nextState.getIn(['data', 'handicaps']).push(fromJS(action.json)));
  }

  if (action.type === `${UPDATE_USER_SCORE}_SUCCESS`) {
    return nextState.setIn(['data', 'scores'], nextState.getIn(['data', 'scores']).push(fromJS(action.json)));
  }

  if (action.type === `${UPDATE_USER_DRIVING_DISTANCE}_SUCCESS`) {
    return nextState.setIn(
      ['data', 'drivingDistances'],
      nextState.getIn(['data', 'drivingDistances']).push(fromJS(action.json))
    );
  }

  if (action.type === `${UPDATE_USER_7IRON_DISTANCE}_SUCCESS`) {
    return nextState.setIn(
      ['data', 'sevenIronDistances'],
      nextState.getIn(['data', 'sevenIronDistances']).push(fromJS(action.json))
    );
  }

  if (action.type === `${COMPLETE_COURSE}_SUCCESS` || action.type === `${COMPLETE_CHAPTER}_SUCCESS`) {
    if (action.json && Object.keys(action.json).length !== 0) {
      return nextState.setIn(['data', 'badges'], nextState.getIn(['data', 'badges']).push(fromJS(action.json)));
    }
  }

  return nextState;
};

const cancelSession = (state = Map({ loaded: false, loading: false, data: null }), action) => {
  switch (action.type) {
    case `${CANCEL_MS_SESSION_FOR_USER}_REQUEST`:
    case `${CANCEL_TATHATA_SESSION_FOR_USER}_REQUEST`:
      return state.merge({
        loading: true,
        loaded: false,
        data: null,
      });
    case `${CANCEL_MS_SESSION_FOR_USER}_SUCCESS`:
    case `${CANCEL_TATHATA_SESSION_FOR_USER}_SUCCESS`:
      return state.merge({
        loading: false,
        loaded: true,
        data: fromJS(action.json),
      });
    case `${CANCEL_MS_SESSION_FOR_USER}_FAILURE`:
    case `${CANCEL_TATHATA_SESSION_FOR_USER}_FAILURE`:
      return state.merge({
        loading: false,
        loaded: false,
        data: null,
      });
    default:
      break;
  }

  return state;
};

export default combineReducers({
  cancelSession,
  courses,
  createSubscription,
  dashboard: getApiReducer(GET_DASHBOARD_DATA),
  profileData: getApiReducer(GET_PROFILE_DATA),
  golfSchools,
  movementSpecialists,
  movementSpecialistAdmin,
  inPersonFollowUp,
  onlineFollowUp,
  sessions,
  swingSubmittals,
  tathataFollowUpData: getApiReducer(GET_TATHATA_FOLLOW_UP_DATA),
  tv,
  user,
  library,
  favorites,
});



// WEBPACK FOOTER //
// ./src/subscription/redux/reducers.js